export function Left({ children, ...props }) {

    return (
        <div {...props}>
            <div className="left">{children}</div>
        </div>
    );
}
